/* eslint-disable react-hooks/exhaustive-deps */
import React, {  } from 'react'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useEventsApi from '../../hooks/events/useEventsApi'
import moment from 'moment-timezone'
import CustomTable from '../customTable/CustomTable'

import SyncIcon from '@material-ui/icons/Sync'

import useUserInvitationApi from '../../hooks/userInvitations/useUserInvitationsApi'
import ListHeader from '../common/ListHeader'

export default function ErrorsList() {
  const [, { updateUserInvitation }] =
    useUserInvitationApi()
  const [{ eventsState }, { getEvents }] = useEventsApi()
  const [{ buildingsState }] = useBuildingsApi()
  const [
,
  ] = useApartmentsApi()
  const columns = [
    {
      id: 'retry',
      label: '',
      minWidth: 70,
      format: (event) => {
        return (
          <SyncIcon
            style={{
              cursor: 'pointer',
              alignItems: 'center',
            }}
            onClick={() =>
              updateUserInvitation(
                event?.payload?.invitation.id,
                event?.payload?.invitation
              )
            }
          />
        )
      },
    },
    {
      id: 'type',
      label: 'Evento',
      minWidth: 170,
      format: () => 'Error al sincronizar con portero',
    },
    {
      id: 'user',
      label: 'Invitado',
      minWidth: 170,
      format: (event) => {
        return `${event.payload?.invitation?.firstName} ${event.payload?.invitation?.lastName}`
      },
    },
    {
      id: 'email',
      label: 'Email',
      minWidth: 100,
      format: (event) => event.payload?.invitation?.email,
    },
    {
      id: 'error',
      label: 'Error',
      minWidth: 170,
      format: (event) => event.payload?.error?.message,
    },
    {
      id: 'building',
      label: 'Cliente',
      minWidth: 100,
      format: (event) => {
        return buildingsState.buildings.find(
          (building) => building.id === event?.payload?.invitation?.buildingId
        )?.name
      },
    },
    {
      id: 'data',
      label: 'Data extra',
      minWidth: 170,
      format: (event) => event.payload?.doorbell?.name,
    },
    {
      id: 'createdAt',
      label: 'Fecha',
      minWidth: 170,
      format: (event) =>
        moment
          .tz(event.createdAt, 'America/Argentina/Buenos_Aires')
          .format('DD/MM/YYYY hh:mm:ss')
          .toLocaleString(),
    },
  ]

  return (
    <>
      <ListHeader bigTitle="Errores" canCreate={false} />
      <CustomTable
        loading={eventsState.isLoading}
        columns={columns}
        data={eventsState.events || []}
        getData={(params) => {
          getEvents({
            errors: true,
            limit: 20,
            offset: 0,
            ...params,
          })
        }}
        buildingFilter={true}
        building={false}
        apartmentFilter={true}
        searchFilter={'Acceso, CI, Empresa, etc'}
        options={false}
        serverPagination={true}
        serverCount={eventsState?.events?.length}
      ></CustomTable>

      {/* {!eventsState.isLoading && !userInvitationState.isLoading && (
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {events &&
                events.map((event) => {
                  const createdAt = moment
                    .tz(event.createdAt, 'America/Argentina/Buenos_Aires')
                    .format('DD/MM/YYYY hh:mm:ss')
                  return (
                    <>
                      <TableRow key={event.id}>
                        {columns.map((column) => {
                          const value = event[column.id]
                          if (column.id === 'retry') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <SyncIcon
                                  style={{
                                    cursor: 'pointer',
                                    alignItems: 'center',
                                  }}
                                  onClick={() =>
                                    updateUserInvitation(
                                      event?.payload?.invitation.id,
                                      event?.payload?.invitation
                                    )
                                  }
                                />
                              </TableCell>
                            )
                          }
                          if (column.id === 'type') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                Error al sincronizar con portero
                              </TableCell>
                            )
                          }
                          if (column.id === 'building') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {
                                  buildingsState.buildings.find(
                                    (building) =>
                                      building.id ===
                                      event?.payload?.invitation?.buildingId
                                  )?.name
                                }
                              </TableCell>
                            )
                          }

                          if (column.id === 'user') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {`${event.payload?.invitation?.firstName} ${event.payload?.invitation?.lastName}`}
                              </TableCell>
                            )
                          }
                          if (column.id === 'email')
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {event.payload?.invitation.email}
                              </TableCell>
                            )
                          if (column.id === 'error')
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {event.payload?.error?.message}
                              </TableCell>
                            )
                          if (column.id === 'data')
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {event.payload?.doorbell?.name}
                              </TableCell>
                            )
                          if (column.id === 'createdAt')
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {`${createdAt.toLocaleString()}`}
                              </TableCell>
                            )
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <TablePagination
        rowsPerPageOptions={[20, 25, 100]}
        component="div"
        count={eventsState.count}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
    </>
  )
}


